<div
  class="relative flex flex-col gap-4 px-2 py-4"
  *hasScope="SCOPES.UNDELIVERED_REASONS.CREATE">

  <!-- Success Notification -->
  @if (showToast()) {
    <app-successful-notification type="success" [title]="toastMessage()" />
  }

  <!-- Breadcrumbs & Page Header -->
  <div class="flex flex-col gap-1">
    <h2 class="textPrimaryColor text-2xl font-bold" i18n="@@createReasonPageTitle">
      Create Undelivered Reason
    </h2>
  </div>

  <!-- Form Card -->
  <div class="bgWhiteColor border-gray-100 rounded-2xl border p-8 shadow-sm">
    <form [formGroup]="reasonForm" (ngSubmit)="onSubmit()" novalidate class="flex flex-col gap-8">
      
      <!-- Inputs Row (2 Columns) -->
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
        
        <!-- Arabic Reason Title Field -->
        <div class="flex flex-col gap-2">
          <label for="reasonAr" class="text-sm font-bold text-gray-800">
            <span i18n="@@reasonTitleAr">Reason Title (Arabic)</span>
            <span class="textPrimaryColor mx-1">*</span>
          </label>

          <input
            type="text"
            id="reasonAr"
            formControlName="reasonAr"
            placeholder="Enter name in Arabic"
            i18n-placeholder="@@placeholderReasonAr"
            class="bgWhiteColor w-full rounded-lg border px-4 py-3 text-sm text-gray-700 outline-none transition-colors placeholder:text-gray-300 focus:border-black"
            [ngClass]="{
              'border-red-500 focus:border-red-500': isFieldInvalid('reasonAr'),
              'border-gray-300 hover:border-gray-400': !isFieldInvalid('reasonAr')
            }" />

          <!-- Validation Errors -->
          @if (isFieldInvalid('reasonAr')) {
            <div class="flex flex-col gap-1 text-xs text-red-500">
              @if (reasonForm.get('reasonAr')?.errors?.['arabicOnly']) {
                <span i18n="@@errorReasonArArabicOnly">Reason Title (Arabic) must contain Arabic letters only</span>
              } @else if (reasonForm.get('reasonAr')?.errors?.['spaces']) {
                <span i18n="@@errorReasonArSpacePadding">Arabic Reason title cannot start or end with spaces</span>
              } @else if (reasonForm.get('reasonAr')?.errors?.['numbers']) {
                <span i18n="@@errorReasonArNoNumbers">Reason Name cannot contain numbers</span>
              } @else if (reasonForm.get('reasonAr')?.errors?.['minlength']) {
                <span i18n="@@errorReasonArMinLength">Reason Name must be at least 3 characters</span>
              } @else if (reasonForm.get('reasonAr')?.errors?.['maxlength']) {
                <span i18n="@@errorReasonArMaxLength">Reason Name cannot exceed 255 characters</span>
              } @else if (reasonForm.get('reasonAr')?.errors?.['required']) {
                <span i18n="@@errorReasonArRequired">Reason Name in Arabic is required</span>
              } @else if (reasonForm.get('reasonAr')?.errors?.['duplicate']) {
                <span i18n="@@errorReasonArDuplicate">A reason with this name in Arabic already exists. Please enter a different name.</span>
              }
            </div>
          }
        </div>

        <!-- English Reason Title Field -->
        <div class="flex flex-col gap-2">
          <label for="reasonEn" class="text-sm font-bold text-gray-800">
            <span i18n="@@reasonTitleEn">Reason Title (English)</span>
          </label>

          <input
            type="text"
            id="reasonEn"
            formControlName="reasonEn"
            placeholder="Enter name in English (optional)"
            i18n-placeholder="@@placeholderReasonEn"
            class="bgWhiteColor w-full rounded-lg border px-4 py-3 text-sm text-gray-700 outline-none transition-colors placeholder:text-gray-300 focus:border-black"
            [ngClass]="{
              'border-red-500 focus:border-red-500': isFieldInvalid('reasonEn'),
              'border-gray-300 hover:border-gray-400': !isFieldInvalid('reasonEn')
            }" />

          <!-- Validation Errors -->
          @if (isFieldInvalid('reasonEn')) {
            <div class="flex flex-col gap-1 text-xs text-red-500">
              @if (reasonForm.get('reasonEn')?.errors?.['englishOnly']) {
                <span i18n="@@errorReasonEnEnglishOnly">Reason Title (English) must contain English letters only</span>
              } @else if (reasonForm.get('reasonEn')?.errors?.['spaces']) {
                <span i18n="@@errorReasonEnSpacePadding">English Reason title cannot start or end with spaces</span>
              } @else if (reasonForm.get('reasonEn')?.errors?.['numbers']) {
                <span i18n="@@errorReasonEnNoNumbers">Reason Name cannot contain numbers</span>
              } @else if (reasonForm.get('reasonEn')?.errors?.['minlength']) {
                <span i18n="@@errorReasonEnMinLength">Reason Name must be at least 3 characters</span>
              } @else if (reasonForm.get('reasonEn')?.errors?.['maxlength']) {
                <span i18n="@@errorReasonEnMaxLength">Reason Name cannot exceed 255 characters</span>
              } @else if (reasonForm.get('reasonEn')?.errors?.['duplicate']) {
                <span i18n="@@errorReasonEnDuplicate">A reason with this name in English already exists. Please enter a different name.</span>
              }
            </div>
          }
        </div>

      </div>

      <!-- Fallback API Error -->
      @if (apiError()) {
        <app-error [apiError]="apiError()" />
      }

      <!-- Actions Buttons Row -->
      <div class="flex items-center justify-end gap-4 pt-2">

        <app-submit-button type="secondary" (click)="onCancel()">
          {{ isArabic() ? 'إلغاء' : 'Cancel' }}
        </app-submit-button>

        <app-submit-button
          type="primary"
          [disabled]="isSubmitting()"
          (click)="onSubmit()">
          @if (isSubmitting()) {
            <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          } @else {
            {{ isArabic() ? 'إرسال' : 'Submit' }}
          }
        </app-submit-button>

      </div>

    </form>
  </div>

  <!-- Submit Confirmation Dialog Component -->
  @if (showConfirmModal()) {
    <app-confirmation-dialog
      layout="start"
      [title]="modalTitle()"
      [description]="modalDescription()"
      [confirmContent]="modalConfirmText()"
      [cancelContent]="modalCancelText()"
      [isLoading]="isSubmitting()"
      (onCancel)="closeConfirmModal()"
      (onSubmit)="confirmSubmit()" />
  }

</div>